import { BillingPlanCodes } from '../../../enums/billing-plan-codes';
import { BillingPlanIds } from '../../../enums/billing-plan-ids';

export type PlanTrialInfo = {
  TrialEndUtc: string;
};

export type PlanTrialHistory = Record<string, PlanTrialInfo>;

export const PLAN_CODE_TO_TIER_NAME: Record<string, string> = {
  [BillingPlanCodes.Standard2025Q2]: 'Standard',
  [BillingPlanCodes.Premium2025Q2]: 'Premium',
};

export const PLAN_CODE_TO_BILLING_PLAN_ID: Record<string, number> = {
  [BillingPlanCodes.Standard2025Q2]: BillingPlanIds.Standard2025Q2,
  [BillingPlanCodes.Premium2025Q2]: BillingPlanIds.Premium2025Q2,
};

/**
 * Maps trialed plan codes to billing plan IDs that satisfy the upgrade (same tier or higher).
 * e.g., trialing Standard → upgrading to Standard OR Premium counts as upgraded
 */
export const TRIALED_PLAN_TO_SATISFYING_UPGRADE_PLAN_IDS: Record<string, number[]> = {
  [BillingPlanCodes.Standard2025Q2]: [
    BillingPlanIds.Standard2025Q2,
    BillingPlanIds.Premium2025Q2,
    BillingPlanIds.Standard2025Q2Annual,
    BillingPlanIds.Premium2025Q2Annual,
  ],
  [BillingPlanCodes.Premium2025Q2]: [BillingPlanIds.Premium2025Q2, BillingPlanIds.Premium2025Q2Annual],
};
